import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";
import "../css/dpi-styles.css";

export default function Surveysearch() {
  const [surveylist, setSurveyList] = useState([]);
  //const [selparam, setSelParam] = useState([]);
  const [survey, setSurvey] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    const getAllSurvey = async () => {
      const resAllSurvey = await fetch(`${API_BASE_URL}GetAllSurvey.php/0`);
      const resallsurvey = await resAllSurvey.json();
      setSurveyList(await resallsurvey.data);
    };
    getAllSurvey();
  }, []);

  const handleviewclick = (params) => {
    sessionStorage.setItem("new_survey", JSON.stringify(params.data));
    navigate("/surveyadd");
  };

  const [surveyColsDef, setSurveyColsDef] = useState([
    {
      field: "surv_id",
      width: 80,
      headerName: "Edit",
      cellRenderer: (params) => (
        <div>
          <i
            className="icon fas fa-edit"
            title="Expand"
            data-toggle="modal"
            data-target="#surveyViewModal"
            onClick={() => handleviewclick(params)}
          />
        </div>
      ),
      filter: false,
    },
    {
      field: "surv_code",
      width: 100,
      headerName: "#Code",
    },
    {
      field: "surv_name",
      width: 200,
      headerName: "Survey",
    },
    {
      field: "surv_desc",
      width: 150,
      headerName: "Description",
    },
    {
      field: "date_start",
      width: 150,
      headerName: "Start",
    },
    {
      field: "date_end",
      width: 150,
      headerName: "End",
    },
    {
      field: "is_publish",
      width: 150,
      headerName: "Published",
      cellRenderer: (params) => (
        <div>{params.data.is_publish !== 1 ? "No" : "Yes"}</div>
      ),
    },
    {
      field: "created_by",
      width: 100,
      headerName: "Created By",
    },
    {
      field: "date_created",
      width: 300,
      headerName: "Date Create",
    },
  ]);
  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    filter: true, // Enable filtering on all columns
  }));

  const handlecreate = () => {
    const errMsg = validateSurvey();
    if (errMsg === "") {
      if (saveSurvey()) {
        navigate("/surveyadd");
        /*setTimeout(() => {
          navigate("/surveyadd"); // Navigate to another page
        }, 100);*/
      }
      //console.log(survey);
    } else {
      alert(errMsg);
    }
  };

  const validateSurvey = () => {
    if (!survey.surv_name) {
      return "Survey name is missing";
    }
    if (!survey.surv_desc) {
      return "Survey description is missing";
    }
    return "";
  };

  const saveSurvey = async () => {
    const formfldData = new FormData();
    formfldData.append("new_survey", JSON.stringify(survey));
    formfldData.append(
      "created_by",
      sessionStorage.getItem("user_credential")
        ? JSON.parse(sessionStorage.getItem("user_credential")).user_name
        : ""
    );

    const templsaver = await axios
      .post(`${API_BASE_URL}InsertSurvey.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        sessionStorage.setItem("new_survey", JSON.stringify(response.data));
        alert(
          "Your survey saved successfully! Now you can proceed to add questions!"
        );
        //console.log(response.data);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  return (
    <div>
      <div
        className="ag-theme-quartz"
        style={{
          width: "80%",
          height: 600,
          marginLeft: "10%",
          marginTop: "3%",
        }}
      >
        <div style={{ borderBottom: true, alignItems: "right" }}>
          <div>
            <ul class="breadcrumb">
              <li className="breadcrumb-item">Survey</li>
              <li className="breadcrumb-item">Search</li>
            </ul>
          </div>

          <button
            className="btn btn-primary"
            type="button"
            data-toggle="modal"
            data-target="#paramModal"
            //onClick={() => handleAddClick()}
          >
            Create Survey
          </button>
        </div>
        <div>&nbsp;</div>
        <AgGridReact
          rowData={surveylist}
          columnDefs={surveyColsDef}
          pagination={true}
          defaultColDef={defaultColDef}
        />
      </div>
      <div
        class="modal fade bd-example-modal-lg"
        id="paramModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="paramModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              Create New Survey
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="row gx-12 mb-3">
                <div className="col-md-12">
                  <label className="btn-outline-danger">*</label>
                  <label className="small mb-1" for="surv_name">
                    Survey Title
                  </label>
                  <input
                    className="form-control"
                    id="surv_name"
                    type="text"
                    placeholder="Survey Title"
                    onChange={(e) =>
                      setSurvey({
                        ...survey,
                        surv_name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="row gx-12 mb-3">
                <div className="col-md-12">
                  <label className="small mb-1" for="surv_desc">
                    Description
                  </label>
                  <input
                    className="form-control"
                    id="surv_desc"
                    type="text"
                    placeholder="Description"
                    onChange={(e) =>
                      setSurvey({
                        ...survey,
                        [e.target.id]: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="row gx-12">
                <div className="col-md-6">
                  <label className="small mb-1" for="date_start">
                    Start Date
                  </label>
                </div>
                <div className="col-md-6">
                  <label className="small mb-1" for="date_end">
                    End Date
                  </label>
                </div>
              </div>
              <div className="row gx-12 mb-3">
                <div className="col-md-6">
                  <ReactDatePicker
                    id="date_start"
                    className="form-control"
                    selected={
                      survey.date_start ? new Date(survey.date_start) : null
                    }
                    onChange={(seldate) =>
                      setSurvey({ ...survey, date_start: seldate })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <ReactDatePicker
                    id="date_end"
                    className="form-control"
                    selected={
                      survey.date_end ? new Date(survey.date_end) : null
                    }
                    onChange={(seldate) =>
                      setSurvey({ ...survey, date_end: seldate })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row gx-12 mb-3">
              <div className="col-md-12">&nbsp;</div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                className="btn btn-primary align-center"
                data-dismiss="modal"
                onClick={() => handlecreate()}
              >
                Create Survey
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
